import { render, staticRenderFns } from "./ListGradedSubmissions.vue?vue&type=template&id=438299c2&scoped=true&"
import script from "./ListGradedSubmissions.vue?vue&type=script&lang=js&"
export * from "./ListGradedSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./ListGradedSubmissions.vue?vue&type=style&index=0&id=438299c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438299c2",
  null
  
)

export default component.exports